import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import SeattleVegansLogo from "../images/SeattleVegansLogo.svg";
import "./Navbar.css";

const MainLogo = styled.img`
  padding-top: 0.25em;
  height: 2em;
  width: auto;
  filter: invert(100%) sepia(10%) saturate(6481%) hue-rotate(246deg)
    brightness(102%) contrast(143%);
`;

function Navbar() {
  const [click, setClick] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  // Handle window resize to detect mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
      if (window.innerWidth > 960) {
        setClick(false); // Close mobile menu when resizing to desktop
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const MainLogo = styled.img`
    padding-top: 0.25em;
    height: 2em;
    width: auto;
    filter: invert(100%) sepia(10%) saturate(6481%) hue-rotate(246deg)
      brightness(102%) contrast(143%);
  `;

  return (
    <>
      <nav className="navbar saira-condensed-semibold">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <MainLogo src={SeattleVegansLogo} />
            <i className="fab fa-typo3" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            {click ? (
              <svg
                className="ham-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="white"
              >
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            ) : (
              <svg
                className="ham-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="white"
              >
                <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
              </svg>
            )}
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/about" className="nav-links" onClick={closeMobileMenu}>
                ABOUT US
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                to="/events"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                UPCOMING EVENTS
              </Link>
            </li> */}
            <li className="nav-item">
              <a
                href="https://linktr.ee/seattlegoesvegan"
                className="nav-links"
                onClick={closeMobileMenu}
                target="_blank"
                rel="noopener noreferrer"
              >
                VEGAN GUIDE
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
